/**
 * global-v2.js
 * 依赖: jQuery
 */
(function () {
  function hideSiteHeader() {
    var headerContainer = document.querySelector('#lt-header-v2');
    var headerV2 = document.querySelector('.header-v2');
    if (!headerContainer) return;
    headerContainer.setAttribute('data-scrollshow', 'false');

    headerV2.style.top = `-100px`;
    headerV2.style.position = 'sticky';
  }

  $(function () {
    window.litime.hideSiteHeader = hideSiteHeader;
    /**
     * global-review-tab-trigger
     * 点击后跳转到 product-tabs-content-v2 的 REVIEW Tab
     */
    $(document).on('click', '.global-review-tab-trigger', function (e) {
      e.preventDefault();

      var tabsRoot = document.querySelector('product-tabs-content-v2');
      var reviewLink = tabsRoot && tabsRoot.querySelector('.product-tabs-content-v2__link[data-tab-type="REVIEW"]');

      if (!reviewLink) {
        console.warn('[global-review-tab-trigger] REVIEW tab link not found');
        return;
      }

      reviewLink.click();
    });

    function isAddToCartLoading(trigger) {
      var innerBtn = trigger.querySelector('.global-button-v2');
      if (innerBtn) {
        return innerBtn.getAttribute('data-loading') === 'true';
      }
      return trigger.dataset.loading === 'true';
    }

    function setAddToCartLoading(trigger, loading) {
      var innerBtn = trigger.querySelector('.global-button-v2');
      if (innerBtn) {
        innerBtn.setAttribute('data-loading', loading ? 'true' : 'false');
        return;
      }
      trigger.dataset.loading = loading ? 'true' : 'false';
      if (loading) {
        trigger.setAttribute('aria-disabled', 'true');
      } else {
        trigger.removeAttribute('aria-disabled');
      }
    }

    async function openProductModalV2WithLoading(shopNowBtn, productHandle) {
      try {
        await window.litime.openProductModalV2(productHandle);
      } catch (err) {
        console.error('[global-add-to-cart-trigger] open modal v2 error:', err);
      } finally {
        setAddToCartLoading(shopNowBtn, false);
      }
    }

    $(document).on('click', '.global-add-to-cart-trigger', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (isAddToCartLoading(this)) return;

      var shopNowBtn = this;
      var variantCount = parseInt(shopNowBtn.dataset.variantCount, 10);
      var productHandle = shopNowBtn.dataset.productHandle;

      if (variantCount > 1) {
        setAddToCartLoading(shopNowBtn, true);

        if (window.litime.version === 'v2' && typeof window.litime.openProductModalV2 === 'function') {
          openProductModalV2WithLoading(shopNowBtn, productHandle);
        } else {
          openQuickView(shopNowBtn, productHandle);
        }

        return;
      }

      var variantId = shopNowBtn.dataset.variantId;
      var quantity = shopNowBtn.dataset.quantity || '1';

      setAddToCartLoading(shopNowBtn, true);

      var sections = [getMiniCartSectionId(), 'cart-icon-bubble'].filter(Boolean);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) || 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (parsedState) {
          if (parsedState.status === 422) {
            window.litime.showToast(parsedState.description, 'error');
          } else {
            if (window.location.pathname === '/cart') {
              window.scrollTo(0, 0);
              window.location.reload();
            } else if (
              typeof (document.querySelector('global-mini-cart-v2, cart-drawer') || {})?.renderContents === 'function'
            ) {
              (document.querySelector('global-mini-cart-v2, cart-drawer') || {}).renderContents(parsedState);
            }
          }
        })
        .catch(function (err) {
          console.error('[global-add-to-cart-trigger] add to cart error:', err);
        })
        .finally(function () {
          setAddToCartLoading(shopNowBtn, false);
        });
    });

    function openQuickView(shopNowBtn, productHandle) {
      window.litime.disableScroll();
      fetch('/products/' + productHandle + '?view=modal')
        .then(function (response) {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(function (responseText) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(responseText, 'text/html');
          doc.querySelectorAll('script').forEach(function (s) {
            s.textContent = '';
          });
          var quickshopPopup =
            (doc.getElementById('quickshop-popup') && doc.getElementById('quickshop-popup').innerHTML) || '';
          $('#global-product-card-popup').html(quickshopPopup);
          setAddToCartLoading(shopNowBtn, false);
          try {
            var popupEl = $('#global-product-card-popup').find('product-detail-data-popup')[0];
            if (popupEl && popupEl.applyPreferentialMode) {
              popupEl.applyPreferentialMode();
            }
          } catch (e) {
            console.warn('[global-add-to-cart-trigger] set preferential data failed:', e);
          }
        })
        .catch(function (err) {
          setAddToCartLoading(shopNowBtn, false);
        });
    }

    window.litime && (window.litime.hideSiteHeader = hideSiteHeader);
    window.hideSiteHeader = hideSiteHeader;
  });
})();
